module.exports = __webpack_public_path__ + "static/media/41-ack-house.c80ed911.jpg";